"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette$text;
  return {
    productTeaser: {
      color: (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : (_theme$palette$text = _theme$palette.text) === null || _theme$palette$text === void 0 ? void 0 : _theme$palette$text.secondary,
      display: "block",
      paddingBottom: theme.spacing(2)
    },
    image: {
      position: "relative"
    },
    fallbackImage: {
      display: "flex",
      minHeight: "100%",
      paddingBottom: "109.375%",
      position: "relative",
      "& .mco-fallback-image": {
        left: 0,
        position: "absolute",
        top: 0
      }
    },
    bookmark: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1)
    },
    content: _defineProperty({
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingTop: theme.spacing(2)
    }, theme.breakpoints.up("sm"), {
      paddingLeft: 0,
      paddingRight: 0
    }),
    title: {
      fontSize: "1.125rem",
      fontWeight: theme.typography.fontWeightBold
    },
    description: {
      fontSize: "0.875rem",
      marginTop: theme.spacing(0.5)
    },
    attributes: {
      fontSize: "0.875rem",
      lineHeight: 1.28,
      marginTop: theme.spacing(0.5),
      "& span": {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    price: {
      marginTop: theme.spacing(1)
    },
    tags: {
      bottom: 0,
      left: 0,
      position: "absolute"
    }
  };
});
var _default = styles;
exports.default = _default;